import { createContext, useContext, useEffect, useRef, useState } from "react";

const RestrictionContext = createContext();

export const MediaRestrictionsProvider = ({ children, idToDisplay }) => {
  const [isBlurred, setIsBlurred] = useState(false);
  const [slideShouldBlur, setSlideShouldBlur] = useState(false);
  const mutationRef = useRef();

  const options = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true,
  };
  const nodeWasDeleted = () => {
    const { current } = mutationRef;
    // console.log(current.children[0]);
    if (current && current.children && current.children.length > 0) {
      // console.log(current.children[0]);
      if (current.children[0].id !== "child") {
        alert("לצרכי אבטחה ותועלת כל משתמשי המערכת, נא לא לנסות שוב");

        // mutationRef.current.
        const child = document.createElement("div");
        child.id = "child";
        child.innerText = idToDisplay;
        child.style = {
          ...child.style,
          position: "absolute",
          top: "50%",
          left: "50%",
          color: "rgba(255,10,10, 0.1)",
          zIndex: 100,
          letterSpacing: "0.32rem",
          backgroundColor: "rgba(128, 128, 128, 0.13)",
          filter: "drop-shadow(0 15px black)",
          pointerEvents: "none",
        };
        const parent = document.getElementById("parent");
        parent.insertBefore(child, parent.firstChild);
      }
    }
  };

  useEffect(() => {
    if (mutationRef.current) {
      const observer = new MutationObserver(nodeWasDeleted);
      observer.observe(mutationRef.current, options);
      return () => observer.disconnect();
    }
  }, [nodeWasDeleted, options]);

  useEffect(() => {
    // Ensure blur state aligns with slideShouldBlur when it changes
    if (isBlurred && !slideShouldBlur) {
      setIsBlurred(false);
    }
  }, [slideShouldBlur, isBlurred]);

  useEffect(() => {
    const handleContextMenu = (event) => {
      event.preventDefault();
    };

    const handleWindowBlur = (e) => {
      // console.log(e.target.AdobeDC);

      if (slideShouldBlur) {
        setIsBlurred(true);
      }
    };

    const handleWindowFocus = () => {
      setIsBlurred(false); // Remove blur effect when window regains focus
    };

    const handleKeyDown = (event) => {
      // Disable Ctrl+P
      if ((event.ctrlKey || event.metaKey) && event.key === "p") {
        event.preventDefault();
        alert("Printing is disabled.");
      }

      // Disable Print Screen key
      if (event.key === "PrintScreen") {
        alert("Screenshots are disabled.");
        document.body.style.visibility = "hidden";
        setTimeout(() => {
          document.body.style.visibility = "visible";
        }, 1000);
      }
    };

    // Add event listeners
    window.addEventListener("contextmenu", handleContextMenu);
    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("blur", handleWindowBlur);
    window.addEventListener("focus", handleWindowFocus);

    return () => {
      // Cleanup listeners when the component unmounts
      window.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("blur", handleWindowBlur);
      window.removeEventListener("focus", handleWindowFocus);
    };
  }, [slideShouldBlur]);

  return (
    <RestrictionContext.Provider value={{ isBlurred, setSlideShouldBlur }}>
      <div
        style={{
          filter: isBlurred ? "blur(20px)" : "none",
          transition: "filter 1ms ease-in-out",
          width: "100%",
          height: "100%",
          position: "relative",
        }}
        ref={mutationRef}
        id="parent"
      >
        <div
          id="child"
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            color: "rgba(255,10,10, 0.3)",
            zIndex: 100,
            letterSpacing: "0.32rem",
            backgroundColor: "rgba(128, 128, 128, 0.1)",
            filter: "drop-shadow(0 15px black)",
            pointerEvents: "none",
          }}
        >
          {idToDisplay}
        </div>
        {children}
      </div>
    </RestrictionContext.Provider>
  );
};

export const useMediaRestrictions = () => useContext(RestrictionContext);
